import { DUR } from '@/animations/settings/vars'
import { cn } from '@/lib/utils'
import { Typo3TitleLayout } from '@/types/typo3'
import { Div, Richtext, Title } from '@/ui/components'
import { TitleProps } from '@/ui/components/Base/Title'
import { memo } from 'react'

const SectionHeaderContent = ({
  children,
  as = 'h2',
  description,
  titleLayout = '2',
  className
}: {
  children: React.ReactNode
  as: TitleProps['as']
  description?: string
  titleLayout?: Typo3TitleLayout
  className?: string
}) => {
  if (!children || titleLayout === '100') {
    return null
  }

  return (
    <Div
      className={cn(
        'mb-md mt-xl relative flex flex-col items-start',
        className
      )}
    >
      <Div
        className={cn(
          'bg-accent-300 py-md pr-lg pl-padding-lg text-neutral-100'
        )}
        anim="fade-in"
        animVars={{ delay: DUR?.stagger ? DUR.stagger * 2 : 0 }}
      >
        <Title as={as} className="h2">
          {children}
        </Title>
      </Div>
      {description && (
        <Div
          className={cn('pl-padding-lg')}
          anim="fade-in"
          animVars={{ delay: DUR?.stagger ? DUR.stagger * 2.5 : 0 }}
        >
          <Richtext
            text={description}
            className="bg-primary-300 px-global py-xs textstyle-md-regular text-neutral-100"
          />
        </Div>
      )}
    </Div>
  )
}

SectionHeaderContent.displayName = 'SectionHeaderContent'

export default memo(SectionHeaderContent)
